import type { TemplateResourceReadV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { TemplateComponentType, TemplateResponseResourceFront } from '../../models/template.model';

export function mapUploadedTemplateFile({
  componentType,
  createdBy,
  creationDate,
  description,
  id,
  name,
  targetLocation,
  templateFileId,
  templateFileName,
  templateFileVersion,
}: TemplateResourceReadV2Api): TemplateResponseResourceFront {
  return {
    componentType: componentType as TemplateComponentType | undefined,
    createdBy,
    creationDate,
    description,
    id,
    name,
    targetLocation,
    templateFileId,
    templateFileName,
    templateFileVersion,
  };
}
